import { render, staticRenderFns } from "./HomeActivities.vue?vue&type=template&id=520e2e97&scoped=true"
import script from "./HomeActivities.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeActivities.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./HomeActivities.vue?vue&type=style&index=0&id=520e2e97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e2e97",
  null
  
)

export default component.exports